var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useMemo } from "react";
import cookies from "../services/cookies";
import { api } from "../services/api";
import { getAuthenticatedUserData, login, logout, validate } from "../services/auth";
import Notification from "../components/Notification";
import useSessionStorage from "../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { setClarityUserTags } from "../utils/clarity";
export var unauthenticatedUser = {
    signed: false,
    id: 0,
    name: "",
    role_id: 0,
    permissions: [""],
    impersonate: false,
    has_unpaid_bills: 0,
    email: "",
};
var SIX_HOURS_IN_MILLISECONDS = 60 * 6 * 60 * 1000;
var AuthContext = createContext({});
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useSessionStorage("user", unauthenticatedUser), auth = _b[0], setAuth = _b[1];
    var navigate = useNavigate();
    useEffect(function () {
        if ((auth === null || auth === void 0 ? void 0 : auth.id) && (auth === null || auth === void 0 ? void 0 : auth.role_id)) {
            setClarityUserTags(auth === null || auth === void 0 ? void 0 : auth.id.toString(), auth.role_id.toString());
        }
    }, [auth === null || auth === void 0 ? void 0 : auth.id, auth === null || auth === void 0 ? void 0 : auth.role_id]);
    var authenticate = function (credentials) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, login(credentials)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var magicAuthenticate = function (jwt, loginToken) { return __awaiter(void 0, void 0, void 0, function () {
        var options, date;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = { path: "/" };
                    date = new Date();
                    date.setTime(date.getTime() + SIX_HOURS_IN_MILLISECONDS);
                    Object.assign(options, { expires: date });
                    cookies.set("token", jwt, options);
                    api.defaults.headers.common["Authorization"] = "Bearer " + cookies.get("token");
                    return [4 /*yield*/, validate({ token: loginToken })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getAuthenticatedUserData().then(function (res) {
                            setAuth({
                                signed: true,
                                id: res.data.user.id,
                                name: res.data.user.name,
                                role_id: res.data.user.role_id,
                                permissions: res.data.permissions,
                                impersonate: false,
                                has_unpaid_bills: res.data.customer.length !== 0 ? res.data.customer.has_unpaid_bills : 0,
                                email: res.data.user.email,
                            });
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var unAuthenticate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logout().then(function () {
                        var date = new Date();
                        date.setTime(date.getTime() - 1);
                        cookies.set("token", "", { path: "/", expires: date });
                        cookies.set("token_old", "", { path: "/", expires: date });
                        cookies.remove("token");
                        cookies.remove("token_old");
                        setAuth(unauthenticatedUser);
                        Notification().Notify.success("Usuário desconectado!");
                    })];
                case 1:
                    _a.sent();
                    api.defaults.headers.common["Authorization"] = "";
                    navigate("/login");
                    return [2 /*return*/];
            }
        });
    }); };
    var authData = useMemo(function () { return ({
        auth: auth,
        setAuth: setAuth,
        authenticate: authenticate,
        magicAuthenticate: magicAuthenticate,
        unAuthenticate: unAuthenticate,
    }); }, [auth]);
    return _jsx(AuthContext.Provider, __assign({ value: authData }, { children: children }));
};
export default AuthContext;
